import { BASE_URL } from './Config.js';

export class BCCService {
  getAllBCC = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      // Appel au BCCController pour la liste (adaptez '/bcc/all' si votre @RequestMapping est différent, ex: '/bon-commande-client/all')
      const response = await fetch(`${BASE_URL}/bcc/all`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erreur chargement liste BCC');
      return await response.json();
    } catch (error) { 
      console.error('Error fetching BCC list:', error); 
      throw error; 
    }
  };

  getBCCById = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/bcc/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erreur chargement détail BCC');
      return await response.json();
    } catch (error) { 
      console.error('Error fetching BCC detail:', error); 
      throw error; 
    }
  };
     // Dans src/services/BCCService.js

  updateBCC = async (id, bccData) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");
      const response = await fetch(`${BASE_URL}/bcc/update/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(bccData)
      });
      if (!response.ok) throw new Error('Erreur mise à jour BCC');
      return await response.json();
    } catch (error) { 
      console.error('Error updating BCC:', error); 
      throw error; 
    }
  };

  // Méthode pour clôturer le BCC
  closeBCC = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");
      
      // Correspond à @PostMapping("/close/{id}") dans BCCController
      const response = await fetch(`${BASE_URL}/bcc/close/${id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erreur clôture BCC');
      return await response.json();
    } catch (error) { 
      console.error('Error closing BCC:', error); 
      throw error; 
    }
  };

   // Nouvelle méthode pour récupérer le BCC par clientId
  getBCCByClientId = async (clientId) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token || !clientId) return null;

      const response = await fetch(`${BASE_URL}/bcc/client/${clientId}`, {
        method: 'GET',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}` 
        }
      });

      if (response.status === 404) {
        return null; // Aucun BCC trouvé pour ce client
      }

      if (!response.ok) {
        console.error("Erreur HTTP lors de la récupération du BCC:", response.status);
        return null;
      }

      return await response.json(); // Retourne le BCCDTO (avec id, devisId, etc.)
      
    } catch (error) {
      console.error("Erreur réseau getBCCByClientId:", error);
      return null;
    }
  };
}